import { useEffect } from "react";

import { AMPLITUDE_EVENT_KEY } from "@simplyk/common";
import { useSearchParams } from "next/navigation";

import { AmplitudeEvents } from "../../constants/amplitude";

import { useAmplitude } from "./useAmplitude";

export const useLogParamsEvent = () => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  const { logAmplitudeEvent } = useAmplitude();
  const amplitudeEvent = query[AMPLITUDE_EVENT_KEY] as AmplitudeEvents | AmplitudeEvents[] | undefined;

  useEffect(() => {
    if (Array.isArray(amplitudeEvent)) {
      amplitudeEvent.map((event) => {
        logAmplitudeEvent(event);
      });
    } else {
      amplitudeEvent && logAmplitudeEvent(amplitudeEvent);
    }
  }, [amplitudeEvent, logAmplitudeEvent]);
};
